import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const LoginPage = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: stretch;
  min-height: 100vh;
  border-radius: 0;
  overflow: hidden;
  font-family: Arial, Helvetica, sans-serif;

  @media (max-width: 900px) {
    flex-direction: column;
    min-height: 100vh;
  }
`;

export const BannerColumn = styled.div`
  flex: 2;
  background: #0d1b2e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 40px;
  position: relative;
  min-width: 0;
  min-height: 0;

  @media (max-width: 900px) {
    padding: 40px 28px 32px;
    flex: 0 0 auto;
  }
`;

export const DecorCircleOuter = styled.div`
  position: absolute;
  width: 800px;
  height: 800px;
  border-radius: 50%;
  border: 1px solid rgba(245, 195, 0, 0.08);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

export const DecorCircleInner = styled.div`
  position: absolute;
  width: 670px;
  height: 670px;
  border-radius: 50%;
  border: 1px solid rgba(245, 195, 0, 0.05);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

export const Tagline = styled.p`
  color: #f5c300;
  font-size: 11px;
  letter-spacing: 5px;
  text-transform: uppercase;
  margin: 0 0 10px;
  font-weight: 400;
  position: relative;
`;

export const BannerSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  text-align: center;
  margin: 0 0 40px;
  line-height: 1.8;
  max-width: 360px;
  position: relative;
`;

export const FeaturesRow = styled.div`
  display: flex;
  gap: 35px;
  position: relative;
  flex-wrap: wrap;
  justify-content: center;
`;

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const FeatureIconWrap = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: rgba(245, 195, 0, 0.1);
  border: 1px solid rgba(245, 195, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeatureLabel = styled.span`
  color: rgba(255, 255, 255, 0.35);
  font-size: 12px;
  letter-spacing: 3px;
`;

export const FormColumn = styled.div`
  flex: 1;
  background: #0f2040;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  padding: 56px clamp(24px, 5vw, 64px);
  min-width: 0;
  min-height: 0;

  @media (max-width: 900px) {
    padding: 36px 24px 44px;
    flex: 1 1 auto;
    align-items: stretch;
  }
`;

/* Ocupa toda a largura da coluna direita (o gargalo era flex do banner, não max-width) */
export const FormInner = styled.div`
  width: 100%;
  max-width: none;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

export const FormTitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 8px;
  line-height: 1.2;

  @media (max-width: 600px) {
    font-size: 26px;
  }
`;

export const FormSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.35);
  font-size: 16px;
  margin: 0;
  line-height: 1.55;
`;

export const FormHeaderBlock = styled.div`
  margin-bottom: 12px;
`;

export const UnderlineFieldWrap = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.22);
  padding-bottom: 12px;
`;

export const UnderlineInput = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 18px;
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.4;
  padding: 6px 0;
  min-height: 28px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.38);
    font-size: 17px;
  }

  @media (max-width: 600px) {
    font-size: 16px;

    &::placeholder {
      font-size: 16px;
    }
  }
`;

export const FieldError = styled.span`
  color: #ff8a80;
  font-size: 13px;
  margin-top: 6px;
  display: block;
`;

export const RememberRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RememberLabel = styled.label`
  color: rgba(255, 255, 255, 0.5);
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  cursor: pointer;
`;

export const ForgotLinkStyled = styled(Link)`
  color: rgba(255, 255, 255, 0.35);
  font-size: 14px;
  text-align: center;
  margin: 0;
  cursor: pointer;
  font-family: Arial, Helvetica, sans-serif;
  text-decoration: none;

  &:hover {
    color: rgba(255, 255, 255, 0.55);
    text-decoration: underline;
  }
`;

export const SubmitButton = styled.button`
  background: #f5c300;
  border: none;
  color: #0d1b2e;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 3px;
  padding: 16px 20px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 8px;
  font-family: Arial, Helvetica, sans-serif;
  transition: background 0.15s ease, transform 0.1s ease;

  &:hover {
    background: #e6b800;
  }

  &:active {
    transform: scale(0.99);
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GridLoading = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0a1628;
`;

export const WhiteCheckbox = withStyles({
  root: {
    color: 'rgba(255,255,255,0.45)',
    padding: 4,
    '&$checked': {
      color: '#f5c300',
    },
    '& svg': {
      fontSize: 26,
    },
  },
  checked: {},
})(Checkbox);
